import { render, staticRenderFns } from "./subsectionPath.vue?vue&type=template&id=8be39c60&scoped=true"
import script from "./subsectionPath.vue?vue&type=script&lang=js"
export * from "./subsectionPath.vue?vue&type=script&lang=js"
import style0 from "./subsectionPath.vue?vue&type=style&index=0&id=8be39c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be39c60",
  null
  
)

export default component.exports